import $ from 'jquery'

$(document).on('click', 'button.btn-upload-award', function () {
  $('#uploadAwardModal').modal('toggle')
})
